import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../Component/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PURCHASE_API } from "../../apiConfig";

// ── styles ──────────────────────────────────────────────────────
const styles = {
  tableContainer: {
    background: "#ffffff",
    borderRadius: 8,
    padding: 12,
    boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
    overflowX: "auto"
  },
  table: {
    width: "100%",
    minWidth: 700,
    borderCollapse: "collapse"
  },
  th: {
    background: "#f8fafc",
    fontSize: 13,
    fontWeight: 600,
    padding: "10px 12px",
    borderBottom: "1px solid #e5e7eb",
    color: "#1e293b",
    whiteSpace: "nowrap",
    textAlign: "left"
  },
  td: {
    fontSize: 13,
    padding: "10px 12px",
    borderBottom: "1px solid #f1f5f9",
    color: "#334155",
    verticalAlign: "middle"
  },
  badge: (label) => ({
    padding: "4px 10px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600,
    color:
      label === "Approved"
        ? "#166534"
        : label === "Rejected"
        ? "#991b1b"
        : label === "Verified"
        ? "#1e40af"
        : "#475569",
    background:
      label === "Approved"
        ? "#dcfce7"
        : label === "Rejected"
        ? "#fee2e2"
        : label === "Verified"
        ? "#dbeafe"
        : "#f1f5f9"
  }),
  filterBar: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: 16,
    marginBottom: 16
  },
  filterLabel: {
    display: "block",
    fontSize: 12,
    fontWeight: 600,
    color: "#334155",
    marginBottom: 5
  },
  filterSelect: {
    width: "100%",
    padding: "7px 10px",
    fontSize: 13,
    color: "#0f172a",
    background: "#fff",
    border: "1px solid #cbd5e1",
    borderRadius: 6,
    outline: "none",
    cursor: "pointer"
  },
  verifyBtn: {
    background: "#1e293b",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    padding: "6px 14px",
    fontSize: 13,
    fontWeight: 600,
    cursor: "pointer"
  },
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(15,23,42,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    padding: 20
  },
  modal: {
    background: "#fff",
    borderRadius: 10,
    width: "100%",
    maxWidth: 1200,
    maxHeight: "92vh",
    overflowY: "auto",
    padding: "24px 28px",
    boxShadow: "0 10px 40px rgba(0,0,0,0.25)"
  },
  modalHeaderTitle: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 20,
    color: "#0f172a"
  },
  // Header fields laid out as a top-labelled grid, same as the GRN modal
  // (label above, value box below, several fields per row).
  headerGrid: {
    display: "grid",
    gridTemplateColumns: "1fr",
    rowGap: 16,
    marginBottom: 20
  },
  headerRow: {
    display: "flex",
    flexDirection: "column",
    gap: 6
  },
  headerLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: "#334155"
  },
  headerFieldRow: {
    display: "flex",
    gap: 8
  },
  headerActual: {
    flex: 1,
    fontSize: 14,
    padding: "8px 10px",
    background: "#f8fafc",
    borderRadius: 6,
    border: "1px solid #e2e8f0",
    color: "#64748b"
  },
  headerInput: (matched) => ({
    flex: 1,
    fontSize: 14,
    padding: "8px 10px",
    borderRadius: 6,
    border: matched ? "1px solid #16a34a" : "1px solid #cbd5e1",
    background: matched ? "#f0fdf4" : "#fff",
    color: "#0f172a",
    outline: "none"
  }),
  // Tabs styled as the same dark/light pill segments as the GRN modal's
  // Basic / Product / Docs tabs.
  tabBar: {
    display: "flex",
    gap: 8,
    margin: "16px 0"
  },
  tabBtn: (active) => ({
    padding: "6px 18px",
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
    background: active ? "#1e293b" : "#f1f5f9",
    color: active ? "#fff" : "#334155"
  }),
  gridWrap: {
    overflowX: "auto",
    marginTop: 10,
    border: "1px solid #e5e7eb",
    borderRadius: 8
  },
  grid: {
    width: "100%",
    minWidth: 1400,
    borderCollapse: "collapse"
  },
  gridTh: {
    background: "#f8fafc",
    fontSize: 13,
    fontWeight: 600,
    padding: "10px 12px",
    borderBottom: "1px solid #e5e7eb",
    color: "#1e293b",
    whiteSpace: "nowrap",
    textAlign: "left"
  },
  gridActualCell: {
    fontSize: 13,
    padding: "10px 12px",
    borderBottom: "1px solid #f1f5f9",
    background: "#fff",
    color: "#334155",
    whiteSpace: "nowrap",
    verticalAlign: "middle"
  },
  gridInputCell: {
    padding: "10px 12px",
    borderBottom: "1px solid #f1f5f9",
    verticalAlign: "middle"
  },
  gridInput: (matched) => ({
    width: "100%",
    fontSize: 13,
    borderColor: matched ? "#16a34a" : "#ced4da",
    background: matched ? "#f0fdf4" : "#fff"
  }),
  disabledField: {
    background: "#e9ecef",
    color: "#64748b",
    cursor: "not-allowed"
  },
  editBtn: {
    background: "#fff",
    color: "#0f172a",
    border: "1px solid #cbd5e1",
    borderRadius: 6,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer"
  },
  footerBar: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
    marginTop: 20,
    paddingTop: 16,
    borderTop: "1px solid #e5e7eb"
  },
  closeBtn: {
    background: "#fff",
    color: "#334155",
    border: "1px solid #cbd5e1",
    borderRadius: 6,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer"
  },
  saveBtn: {
    background: "#1e293b",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    padding: "8px 20px",
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer"
  },
  reviewNotice: {
    fontSize: 13,
    color: "#92400e",
    background: "#fef3c7",
    border: "1px solid #fde68a",
    borderRadius: 6,
    padding: "10px 14px",
    marginBottom: 14
  },
  // Active / Verified pill toggle above the list table
  listToggleRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 10
  },
  listToggleGroup: {
    display: "inline-flex",
    background: "#f1f5f9",
    borderRadius: 8,
    padding: 4,
    gap: 2
  },
  listToggleBtn: (active) => ({
    padding: "6px 18px",
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
    background: active ? "#ffffff" : "transparent",
    color: active ? "#0f172a" : "#64748b",
    boxShadow: active ? "0 1px 3px rgba(0,0,0,0.12)" : "none"
  })
};

// Product grid columns: [key, label]
// Total Cost / Net Price / CGST / SGST / IGST / Grand Total now come
// straight off goods_receipt (populated on save for BOTH PO-based and
// manual GRNs — see Goodsreceipt.service.js), so they're shown for every
// GRN rather than being conditional on having a purchase_order_no.
const BASE_PRODUCT_COLUMNS = [
  ["product_code", "Product Code"],
  ["description", "Description"],
  ["currency", "Currency"],
  ["product_cost", "Product Cost"],
  ["batch_number", "Batch No"],
  ["uom", "UOM"],
  ["received_qty", "Received Qty"]
];

const COST_COLUMNS = [
  ["total_cost", "Total Cost"],
  ["net_price", "Net Price"],
  ["cgst", "CGST"],
  ["sgst", "SGST"],
  ["igst", "IGST"],
  ["grand_total", "Grand Total"]
];

const TAIL_PRODUCT_COLUMNS = [
  ["delivery_date", "Delivery Date"],
  ["received_date", "Received Date"]
];

const getProductColumns = () => [
  ...BASE_PRODUCT_COLUMNS,
  ...COST_COLUMNS,
  ...TAIL_PRODUCT_COLUMNS
];

const HEADER_FIELDS = [
  ["grn_number", "GRN Number"],
  ["purchase_order_no", "Purchase Order No"],
  ["supplier", "Supplier"],
  ["invoice_no", "Invoice No"]
];

// Normalize a value (from actual data or supplier_batches array) for comparison
const normalize = (val) => {
  if (val === null || val === undefined) return "";
  if (Array.isArray(val)) {
    return val.filter(Boolean).map((v) => String(v).trim().toLowerCase()).sort().join(",");
  }
  return String(val).trim().toLowerCase();
};

const displayValue = (val) => {
  if (val === null || val === undefined || val === "") return "—";
  if (Array.isArray(val)) return val.filter(Boolean).join(", ") || "—";
  return String(val);
};

// Any field listed here is always rendered as dd/mm/yyyy, regardless of
// what format it's stored in (ISO string, Date object, etc.).
const DATE_FIELDS = new Set(["delivery_date", "received_date"]);

const formatDate = (val) => {
  if (val === null || val === undefined || val === "") return null;
  const d = val instanceof Date ? val : new Date(val);
  if (isNaN(d.getTime())) return String(val); // unparsable — show raw rather than hide it
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

// Same as displayValue, but formats known date fields as dd/mm/yyyy.
const displayCell = (key, val) => {
  if (DATE_FIELDS.has(key)) {
    if (val === null || val === undefined || val === "") return "—";
    return formatDate(val) || "—";
  }
  return displayValue(val);
};

// True when there's no actual data to compare against (e.g. manual GRNs
// with no Purchase Order). These fields shouldn't be able to block
// verification just because there's nothing there to type in.
const isBlank = (val) => normalize(val) === "";

// Turns an actual GRN value into the string an <input> should show —
// used to prefill the invoice-entry fields with the GRN's own data so the
// user only has to retype something if the invoice actually differs.
const prefillValue = (val, key) => {
  if (DATE_FIELDS.has(key)) return formatDate(val) || "";
  if (Array.isArray(val)) return val.filter(Boolean).join(", ");
  return val === null || val === undefined ? "" : String(val);
};

const isMatch = (actual, entered) => {
  if (entered === "" || entered === undefined) return false;
  return normalize(actual) === normalize(entered);
};

// Whether a field counts as "satisfied" for the purposes of deciding
// Verified vs Not Verified — blank actual values are auto-satisfied
// since there's nothing on the GRN to match against.
const isSatisfied = (actual, entered) => {
  if (isBlank(actual)) return true;
  return isMatch(actual, entered);
};

// The Status shown to the user has three stages, independent of the raw
// "Pending" default some GRN rows already carry in the DB:
//   Pending          — nothing typed in yet
//   Verified         — invoice values have been typed in and saved (the
//                      Verify step) but no Approve/Reject decision yet
//   Approved / Rejected — a final decision has been saved
// Once an Approved invoice is later paid via the Supplier Payment screen,
// goods_receipt.invoice_verification_status becomes "Payment Complete" —
// but that's a payment-workflow state, not an invoice-verification one, so
// this screen keeps showing it as "Approved" (Payment Complete only shows
// on the Supplier Payment screen). Only "Invoice Verified" / "Invoice Not
// Verified" / "Payment Complete" count as finalized — any other raw value
// (null, "", or the DB's own default "Pending") does not.
const isFinalized = (rawStatus) =>
  rawStatus === "Invoice Verified" ||
  rawStatus === "Invoice Not Verified" ||
  rawStatus === "Payment Complete";

const getStatusLabel = (rawStatus, hasEnteredValues) => {
  if (rawStatus === "Invoice Verified" || rawStatus === "Payment Complete") return "Approved";
  if (rawStatus === "Invoice Not Verified") return "Rejected";
  if (hasEnteredValues) return "Verified";
  return "Pending";
};

function InvoiceVerification() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  // Active / Verified / Approved toggle above the list table.
  //   active   — still Pending (nothing verified yet)
  //   verified — invoice values saved via the Verify step, awaiting an
  //              Approve/Reject decision (Rejected rows also stay here)
  //   approved — a final Approve decision has been made (this includes
  //              GRNs later marked "Payment Complete")
  const [listTab, setListTab] = useState("active"); // "active" | "verified" | "approved"

  // Filters for the list table (GRN Number / PO No / Invoice No / Vendor Name)
  const [filters, setFilters] = useState({
    grn_number: "",
    purchase_order_no: "",
    invoice_no: "",
    vendor_name: ""
  });

  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState(null); // { header, products }

  // "Create" popup — lets the user pick a GRN via dropdowns (GRN Number /
  // PO No / Invoice No / Vendor Name, same fields as the filter bar) and
  // jump straight into the same Verify modal used from the table row.
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createSelection, setCreateSelection] = useState({
    grn_number: "",
    purchase_order_no: "",
    invoice_no: "",
    vendor_name: ""
  });
  const [headerInputs, setHeaderInputs] = useState({});
  const [productInputs, setProductInputs] = useState([]); // array parallel to products
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState("product"); // "product" | "review"

  // Tracks the last-saved (Verify) snapshot so the Verify button can be
  // disabled right after saving, but re-enabled the moment something is edited.
  const [savedSnapshot, setSavedSnapshot] = useState("");
  const [hasSavedOnce, setHasSavedOnce] = useState(false);
  // Locked (read-only) once a GRN has already been verified before; the
  // "Edit" button switches this on so fields become editable again.
  const [isEditing, setIsEditing] = useState(true);

  // Which product rows are selected for Approve/Reject on the Review tab —
  // lets the user approve/reject a subset when a GRN has multiple products.
  const [selectedProducts, setSelectedProducts] = useState([]);

  // Total Cost / Net Price / GST / Grand Total columns are shown for every
  // GRN — goods_receipt carries these fields for PO-based and manual GRNs alike.
  const productColumns = getProductColumns();

  const loadList = () => {
    setLoading(true);
    axios
      .get(`${PURCHASE_API}/invoice-verification/list`)
      .then((res) => setList(res.data?.data || []))
      .catch((err) => {
        console.error("VERIFICATION LIST ERROR:", err);
        toast.error("Failed to load invoice verification list");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadList();
  }, []);

  const openVerifyModal = async (grnNumber) => {
    try {
      const res = await axios.get(`${PURCHASE_API}/invoice-verification/grn/${grnNumber}`);
      if (!res.data?.success) {
        toast.error("Could not load GRN for verification");
        return;
      }
      const { header, products, savedInputs } = res.data;
      setDetail({ header, products });

      // Default every input to the GRN's own value (formatted the same way
      // it's displayed) so the field is already "filled in" and the user
      // only needs to edit it if the invoice actually says something
      // different. A previously-saved invoice entry (savedInputs) always
      // wins over this default. Fields with no actual data stay blank —
      // they render as the disabled "N/A" box regardless.
      const initialHeaderInputs = HEADER_FIELDS.reduce((acc, [key]) => {
        const saved = savedInputs?.header?.[key];
        acc[key] =
          saved !== undefined && saved !== null && saved !== ""
            ? saved
            : isBlank(header[key])
            ? ""
            : prefillValue(header[key], key);
        return acc;
      }, {});
      const cols = getProductColumns();
      const initialProductInputs = products.map((prod, idx) =>
        cols.reduce((acc, [key]) => {
          const saved = savedInputs?.products?.[idx]?.[key];
          acc[key] =
            saved !== undefined && saved !== null && saved !== ""
              ? saved
              : isBlank(prod[key])
              ? ""
              : prefillValue(prod[key], key);
          return acc;
        }, {})
      );

      setHeaderInputs(initialHeaderInputs);
      setProductInputs(initialProductInputs);
      setSavedSnapshot(JSON.stringify({ header: initialHeaderInputs, products: initialProductInputs }));
      setHasSavedOnce(Boolean(header.has_entered_values));
      setIsEditing(!header.has_entered_values);
      setSelectedProducts(products.map(() => true));
      setActiveTab("product");
      setShowModal(true);
    } catch (err) {
      console.error("GRN DETAIL ERROR:", err);
      toast.error("Failed to load GRN details");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setDetail(null);
    setHeaderInputs({});
    setProductInputs([]);
    setActiveTab("product");
    setSavedSnapshot("");
    setHasSavedOnce(false);
    setIsEditing(true);
    setSelectedProducts([]);
  };

  // ── Create popup handlers ──
  // const openCreateModal = () => {
  //   setCreateSelection({ grn_number: "", purchase_order_no: "", invoice_no: "", vendor_name: "" });
  //   setShowCreateModal(true);
  // };

  const closeCreateModal = () => {
    setShowCreateModal(false);
    setCreateSelection({ grn_number: "", purchase_order_no: "", invoice_no: "", vendor_name: "" });
  };

  const handleCreateSelectionChange = (key, value) => {
    setCreateSelection((prev) => {
      const updated = { ...prev, [key]: value };
      // Picking any one field narrows the GRN to a single row, so if that
      // row is unambiguous, auto-fill the rest to save re-selecting them.
      const candidates = list.filter((row) =>
        Object.entries(updated).every(([k, v]) => !v || String(row[k] || "") === v)
      );
      if (candidates.length === 1) {
        const row = candidates[0];
        return {
          grn_number: String(row.grn_number || ""),
          purchase_order_no: String(row.purchase_order_no || ""),
          invoice_no: String(row.invoice_no || ""),
          vendor_name: String(row.vendor_name || "")
        };
      }
      return updated;
    });
  };

  const handleCreateProceed = () => {
    if (!createSelection.grn_number) return;
    setShowCreateModal(false);
    openVerifyModal(createSelection.grn_number);
  };

  const toggleProductSelected = (idx) => {
    setSelectedProducts((prev) => {
      const updated = [...prev];
      updated[idx] = !updated[idx];
      return updated;
    });
  };

  const toggleSelectAllProducts = (checked) => {
    setSelectedProducts((prev) => prev.map(() => checked));
  };

  const handleHeaderInputChange = (key, value) => {
    setHeaderInputs((prev) => ({ ...prev, [key]: value }));
  };

  const handleProductInputChange = (rowIdx, key, value) => {
    setProductInputs((prev) => {
      const updated = [...prev];
      updated[rowIdx] = { ...updated[rowIdx], [key]: value };
      return updated;
    });
  };

  // const allHeaderMatch = () =>
  //   detail
  //     ? HEADER_FIELDS.every(([key]) => isSatisfied(detail.header[key], headerInputs[key]))
  //     : false;

  // const allProductsMatch = () =>
  //   detail
  //     ? detail.products.every((row, idx) =>
  //         productColumns.every(([key]) => isSatisfied(row[key], productInputs[idx]?.[key]))
  //       )
  //     : false;

  // Whether every enterable field (i.e. not N/A) has something typed in —
  // this is what "verification" means before Approve/Reject unlock.
  const allFieldsEntered = () => {
    if (!detail) return false;
    const headerDone = HEADER_FIELDS.every(
      ([key]) => isBlank(detail.header[key]) || String(headerInputs[key] || "").trim() !== ""
    );
    const productsDone = detail.products.every((row, idx) =>
      productColumns.every(
        ([key]) => isBlank(row[key]) || String(productInputs[idx]?.[key] || "").trim() !== ""
      )
    );
    return headerDone && productsDone;
  };

  // True once something has changed since the last successful Verify save
  // (or when nothing has ever been saved yet). Used to re-enable the
  // Verify button only after an edit.
  const isDirty = () =>
    JSON.stringify({ header: headerInputs, products: productInputs }) !== savedSnapshot;

  // Approve / Reject are only allowed AFTER the invoice values have been
  // Verified (saved with the Verify button on the Product tab) and nothing
  // has been edited since. Pre-filled values alone don't count.
  const isVerifiedAndSaved = () => hasSavedOnce && !isDirty();

  const totalFieldCount = () =>
    detail ? HEADER_FIELDS.length + detail.products.length * productColumns.length : 0;

  const satisfiedFieldCount = () => {
    if (!detail) return 0;
    let count = 0;
    HEADER_FIELDS.forEach(([key]) => {
      if (isSatisfied(detail.header[key], headerInputs[key])) count++;
    });
    detail.products.forEach((row, idx) => {
      productColumns.forEach(([key]) => {
        if (isSatisfied(row[key], productInputs[idx]?.[key])) count++;
      });
    });
    return count;
  };

  // "Verify →" on the Product tab — saves what was typed (for pre-fill next
  // time) but does NOT decide Approve/Reject. Closes the modal afterwards;
  // the person reopens the GRN later and switches to the Review tab to
  // actually Approve or Reject.
  const handleSaveValues = async () => {
    if (!detail) return;

    setSaving(true);
    try {
      await axios.put(`${PURCHASE_API}/invoice-verification/save/${detail.header.grn_number}`, {
        entered_values: { header: headerInputs, products: productInputs }
      });
      setSavedSnapshot(JSON.stringify({ header: headerInputs, products: productInputs }));
      setHasSavedOnce(true);
      setIsEditing(false);
      toast.success("Invoice values verified. Click Edit if you need to change anything.");
      loadList();
    } catch (err) {
      console.error("SAVE ENTERED VALUES ERROR:", err);
      toast.error("Failed to save entered values");
    } finally {
      setSaving(false);
    }
  };

  // status is chosen explicitly by the user via Approve / Reject on the
  // Review tab — it is only reachable once every field has been entered.
  // The modal stays open after saving so the Status column updates and the
  // Approve/Reject buttons disable themselves once a decision has been made.
  const handleDecision = async (status) => {
    if (
      !detail ||
      !allFieldsEntered() ||
      !isVerifiedAndSaved() ||
      isFinalized(detail.header.invoice_verification_status)
    ) return;

    setSaving(true);
    try {
      await axios.put(`${PURCHASE_API}/invoice-verification/verify/${detail.header.grn_number}`, {
        invoice_verification_status: status,
        entered_values: { header: headerInputs, products: productInputs }
      });
      toast.success(`Invoice ${getStatusLabel(status, true)}`);
      setDetail((prev) =>
        prev ? { ...prev, header: { ...prev.header, invoice_verification_status: status } } : prev
      );
      loadList();
    } catch (err) {
      console.error("SAVE VERIFICATION ERROR:", err);
      toast.error("Failed to save verification status");
    } finally {
      setSaving(false);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const uniqueValues = (key) =>
    Array.from(new Set(list.map((row) => row[key]).filter(Boolean))).sort();

  const filterOptions = {
    grn_number: uniqueValues("grn_number"),
    purchase_order_no: uniqueValues("purchase_order_no"),
    invoice_no: uniqueValues("invoice_no"),
    vendor_name: uniqueValues("vendor_name")
  };

  const filteredList = list.filter((row) => {
    const matches = (val, filterVal) => !filterVal || String(val || "") === filterVal;
    const label = getStatusLabel(row.invoice_verification_status, Boolean(row.has_entered_values));
    const tabMatch =
      listTab === "active"
        ? label === "Pending"
        : listTab === "verified"
        ? label === "Verified" || label === "Rejected"
        : label === "Approved";
    return (
      tabMatch &&
      matches(row.grn_number, filters.grn_number) &&
      matches(row.purchase_order_no, filters.purchase_order_no) &&
      matches(row.invoice_no, filters.invoice_no) &&
      matches(row.vendor_name, filters.vendor_name)
    );
  });

  const modalStatusLabel = detail
    ? getStatusLabel(detail.header.invoice_verification_status, detail.header.has_entered_values)
    : "Pending";

  return (
    <Layout title="Invoice Verification">
      <ToastContainer position="top-right" autoClose={2500} />
      <div className="container-fluid">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>Invoice Verification</h3>
          {/* <button style={styles.verifyBtn} onClick={openCreateModal}>
            + Create
          </button> */}
        </div>

        <div style={styles.filterBar}>
          <div>
            <label style={styles.filterLabel}>GRN Number</label>
            <select
              style={styles.filterSelect}
              value={filters.grn_number}
              onChange={(e) => handleFilterChange("grn_number", e.target.value)}
            >
              <option value="">Select</option>
              {filterOptions.grn_number.map((val) => (
                <option key={val} value={val}>{val}</option>
              ))}
            </select>
          </div>
          <div>
            <label style={styles.filterLabel}>Purchase Order No.</label>
            <select
              style={styles.filterSelect}
              value={filters.purchase_order_no}
              onChange={(e) => handleFilterChange("purchase_order_no", e.target.value)}
            >
              <option value="">Select</option>
              {filterOptions.purchase_order_no.map((val) => (
                <option key={val} value={val}>{val}</option>
              ))}
            </select>
          </div>
          <div>
            <label style={styles.filterLabel}>Invoice No.</label>
            <select
              style={styles.filterSelect}
              value={filters.invoice_no}
              onChange={(e) => handleFilterChange("invoice_no", e.target.value)}
            >
              <option value="">Select</option>
              {filterOptions.invoice_no.map((val) => (
                <option key={val} value={val}>{val}</option>
              ))}
            </select>
          </div>
          <div>
            <label style={styles.filterLabel}>Vendor Name</label>
            <select
              style={styles.filterSelect}
              value={filters.vendor_name}
              onChange={(e) => handleFilterChange("vendor_name", e.target.value)}
            >
              <option value="">Select</option>
              {filterOptions.vendor_name.map((val) => (
                <option key={val} value={val}>{val}</option>
              ))}
            </select>
          </div>
        </div>

        <div style={styles.listToggleRow}>
          <div style={styles.listToggleGroup}>
            <button style={styles.listToggleBtn(listTab === "active")} onClick={() => setListTab("active")}>
              Active
            </button>
            <button style={styles.listToggleBtn(listTab === "verified")} onClick={() => setListTab("verified")}>
              Verified
            </button>
            <button style={styles.listToggleBtn(listTab === "approved")} onClick={() => setListTab("approved")}>
              Approved
            </button>
          </div>
        </div>

        <div style={styles.tableContainer}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>GRN Number</th>
                <th style={styles.th}>Purchase Order No.</th>
                <th style={styles.th}>Invoice No.</th>
                <th style={styles.th}>Vendor Name</th>
                <th style={styles.th}>Status</th>
                <th style={{ ...styles.th, textAlign: "center" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td style={styles.td} colSpan={6}>Loading...</td>
                </tr>
              ) : filteredList.length === 0 ? (
                <tr>
                  <td style={styles.td} colSpan={6}>
                    {listTab === "active"
                      ? "No pending GRNs to verify."
                      : listTab === "verified"
                      ? "No verified GRNs yet."
                      : "No approved GRNs yet."}
                  </td>
                </tr>
              ) : (
                filteredList.map((row) => (
                  <tr key={row.grn_number}>
                    <td style={styles.td}>{row.grn_number}</td>
                    <td style={styles.td}>{row.purchase_order_no || "—"}</td>
                    <td style={styles.td}>{row.invoice_no || "—"}</td>
                    <td style={styles.td}>{row.vendor_name || "—"}</td>
                    <td style={styles.td}>
                      {(() => {
                        const label = getStatusLabel(row.invoice_verification_status, Boolean(row.has_entered_values));
                        return <span style={styles.badge(label)}>{label}</span>;
                      })()}
                    </td>
                    <td style={{ ...styles.td, textAlign: "center" }}>
                      <button style={styles.verifyBtn} onClick={() => openVerifyModal(row.grn_number)}>
                        Verify
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {showCreateModal && (
        <div style={styles.overlay} onClick={closeCreateModal}>
          <div style={{ ...styles.modal, maxWidth: 520 }} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeaderTitle}>Create Invoice Verification</div>

            <div style={{ ...styles.filterBar, gridTemplateColumns: "1fr 1fr", marginBottom: 20 }}>
              <div>
                <label style={styles.filterLabel}>GRN Number</label>
                <select
                  style={styles.filterSelect}
                  value={createSelection.grn_number}
                  onChange={(e) => handleCreateSelectionChange("grn_number", e.target.value)}
                >
                  <option value="">Select</option>
                  {filterOptions.grn_number.map((val) => (
                    <option key={val} value={val}>{val}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.filterLabel}>Purchase Order No.</label>
                <select
                  style={styles.filterSelect}
                  value={createSelection.purchase_order_no}
                  onChange={(e) => handleCreateSelectionChange("purchase_order_no", e.target.value)}
                >
                  <option value="">Select</option>
                  {filterOptions.purchase_order_no.map((val) => (
                    <option key={val} value={val}>{val}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.filterLabel}>Invoice No.</label>
                <select
                  style={styles.filterSelect}
                  value={createSelection.invoice_no}
                  onChange={(e) => handleCreateSelectionChange("invoice_no", e.target.value)}
                >
                  <option value="">Select</option>
                  {filterOptions.invoice_no.map((val) => (
                    <option key={val} value={val}>{val}</option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.filterLabel}>Vendor Name</label>
                <select
                  style={styles.filterSelect}
                  value={createSelection.vendor_name}
                  onChange={(e) => handleCreateSelectionChange("vendor_name", e.target.value)}
                >
                  <option value="">Select</option>
                  {filterOptions.vendor_name.map((val) => (
                    <option key={val} value={val}>{val}</option>
                  ))}
                </select>
              </div>
            </div>

            {!createSelection.grn_number && (
              <div style={{ fontSize: 12, color: "#64748b", marginBottom: 14 }}>
                Pick a GRN Number (or narrow it down via PO / Invoice / Vendor) to continue.
              </div>
            )}

            <div style={styles.footerBar}>
              <button style={styles.closeBtn} onClick={closeCreateModal}>Cancel</button>
              <button
                style={styles.saveBtn}
                onClick={handleCreateProceed}
                disabled={!createSelection.grn_number}
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && detail && (
        <div style={styles.overlay} onClick={closeModal}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <div style={styles.modalHeaderTitle}>
              Verify Invoice — GRN: {detail.header.grn_number}
              <span style={{ fontSize: 13, fontWeight: 600, marginLeft: 14, color: satisfiedFieldCount() === totalFieldCount() ? "#16a34a" : "#64748b" }}>
                {satisfiedFieldCount()} / {totalFieldCount()} fields matched
                {satisfiedFieldCount() !== totalFieldCount() ? " — scroll the table right to check all columns" : ""}
              </span>
            </div>

            {/* Header fields — top-labelled grid, actual value + invoice input side by side, matching the GRN modal's field layout */}
            <div style={styles.headerGrid}>
              {HEADER_FIELDS.map(([key, label]) => {
                const blank = isBlank(detail.header[key]);
                const matched = isMatch(detail.header[key], headerInputs[key]);
                return (
                  <div style={styles.headerRow} key={key}>
                    <div style={styles.headerLabel}>{label}</div>
                    <div style={styles.headerFieldRow}>
                      <div style={styles.headerActual}>{displayValue(detail.header[key])}</div>
                      {blank ? (
                        <div style={{ ...styles.headerInput(true), color: "#94a3b8", background: "#f1f5f9", border: "1px solid #e2e8f0" }}>
                          N/A
                        </div>
                      ) : activeTab === "product" ? (
                        <input
                          style={{
                            ...styles.headerInput(matched),
                            ...(isEditing ? {} : styles.disabledField)
                          }}
                          placeholder={`Enter ${label}`}
                          value={headerInputs[key] || ""}
                          onChange={(e) => handleHeaderInputChange(key, e.target.value)}
                          disabled={!isEditing}
                        />
                      ) : (
                        <div style={styles.headerInput(matched)}>{displayValue(headerInputs[key])}</div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            <div style={{ margin: "10px 0", display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: "#334155" }}>Status:</span>
              <span style={styles.badge(modalStatusLabel)}>{modalStatusLabel}</span>
            </div>

            <div style={styles.tabBar}>
              {["product", "review"].map((tab) => (
                <button
                  key={tab}
                  style={styles.tabBtn(activeTab === tab)}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "product" ? "Product" : "Review"}
                </button>
              ))}
            </div>

            {activeTab === "product" && (
              <>
                {/* Product grid — actual row + input row per line */}
                <div style={styles.gridWrap}>
                  <table style={styles.grid}>
                    <thead>
                      <tr>
                        {productColumns.map(([key, label]) => (
                          <th style={styles.gridTh} key={key}>{label}</th>
                        ))}
                        <th style={styles.gridTh}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detail.products.map((row, idx) => (
                        <React.Fragment key={idx}>
                          {/* Actual data row (read-only, from GRN) */}
                          <tr>
                            {productColumns.map(([key]) => (
                              <td style={styles.gridActualCell} key={key}>
                                {displayCell(key, row[key])}
                              </td>
                            ))}
                            <td style={styles.gridActualCell} rowSpan={2}>
                              <span style={styles.badge(modalStatusLabel)}>{modalStatusLabel}</span>
                            </td>
                          </tr>
                          {/* Input row — user types what's on the invoice */}
                          <tr>
                            {productColumns.map(([key]) => {
                              const blank = isBlank(row[key]);
                              const matched = isMatch(row[key], productInputs[idx]?.[key]);
                              return (
                                <td style={styles.gridInputCell} key={key}>
                                  {blank ? (
                                    <input
                                      className="form-control form-control-sm p-1 text-center"
                                      style={{ fontSize: 12 }}
                                      value="N/A"
                                      disabled
                                    />
                                  ) : (
                                    <input
                                      className="form-control form-control-sm p-1"
                                      style={styles.gridInput(matched)}
                                      placeholder={DATE_FIELDS.has(key) ? "DD/MM/YYYY" : ""}
                                      value={productInputs[idx]?.[key] || ""}
                                      onChange={(e) => handleProductInputChange(idx, key, e.target.value)}
                                      disabled={!isEditing}
                                    />
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {activeTab === "review" && (
              <div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginBottom: 10 }}>
                  <button
                    style={styles.saveBtn}
                    onClick={() => handleDecision("Invoice Verified")}
                    disabled={
                      !allFieldsEntered() ||
                      !isVerifiedAndSaved() ||
                      saving ||
                      isFinalized(detail.header.invoice_verification_status) ||
                      !selectedProducts.some(Boolean)
                    }
                  >
                    {saving ? "Saving..." : "Approve"}
                  </button>
                  <button
                    style={styles.closeBtn}
                    onClick={() => handleDecision("Invoice Not Verified")}
                    disabled={
                      !allFieldsEntered() ||
                      !isVerifiedAndSaved() ||
                      saving ||
                      isFinalized(detail.header.invoice_verification_status) ||
                      !selectedProducts.some(Boolean)
                    }
                  >
                    {saving ? "Saving..." : "Reject"}
                  </button>
                </div>

                {!allFieldsEntered() && !isFinalized(detail.header.invoice_verification_status) && (
                  <div style={styles.reviewNotice}>
                    Enter the invoice values for every field on the Product tab before you can Approve or Reject.
                  </div>
                )}

                {allFieldsEntered() && !isVerifiedAndSaved() && !isFinalized(detail.header.invoice_verification_status) && (
                  <div style={styles.reviewNotice}>
                    Click Verify on the Product tab to save the invoice values first — only a verified invoice can be Approved or Rejected.
                  </div>
                )}

               

                <div style={styles.gridWrap}>
                  <table style={styles.grid}>
                    <thead>
                      <tr>
                        <th style={{ ...styles.gridTh, width: 36 }}>
                          <input
                            type="checkbox"
                            checked={selectedProducts.length > 0 && selectedProducts.every(Boolean)}
                            onChange={(e) => toggleSelectAllProducts(e.target.checked)}
                            disabled={isFinalized(detail.header.invoice_verification_status)}
                          />
                        </th>
                        {productColumns.map(([key, label]) => (
                          <th style={styles.gridTh} key={key}>{label}</th>
                        ))}
                        <th style={styles.gridTh}>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detail.products.map((row, idx) => (
                        <tr key={idx}>
                          <td style={styles.gridActualCell}>
                            <input
                              type="checkbox"
                              checked={Boolean(selectedProducts[idx])}
                              onChange={() => toggleProductSelected(idx)}
                              disabled={isFinalized(detail.header.invoice_verification_status)}
                            />
                          </td>
                          {productColumns.map(([key]) => (
                            <td style={styles.gridActualCell} key={key}>
                              {displayCell(key, row[key])}
                            </td>
                          ))}
                          <td style={styles.gridActualCell}>
                            <span style={styles.badge(modalStatusLabel)}>{modalStatusLabel}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div style={{ fontSize: 12, color: "#64748b", marginTop: 6 }}>
                  {isFinalized(detail.header.invoice_verification_status)
                    ? "A final decision has been made — product selection is locked."
                    : "Uncheck a product to leave it out of this Approve/Reject decision."}
                </div>
              </div>
            )}

            <div style={styles.footerBar}>
              {activeTab === "product" && (
                isEditing ? (
                  <button
                    style={styles.saveBtn}
                    onClick={handleSaveValues}
                    disabled={saving || (hasSavedOnce && !isDirty())}
                    title={hasSavedOnce && !isDirty() ? "Nothing changed yet — edit a value first" : ""}
                  >
                    {saving ? "Saving..." : hasSavedOnce && !isDirty() ? "Verified" : "Verify"}
                  </button>
                ) : (
                  <button
                    style={{
                      ...styles.editBtn,
                      ...(isFinalized(detail.header.invoice_verification_status) ? styles.disabledField : {})
                    }}
                    onClick={() => setIsEditing(true)}
                    disabled={isFinalized(detail.header.invoice_verification_status)}
                    title={isFinalized(detail.header.invoice_verification_status) ? "Already approved/rejected — values are locked" : ""}
                  >
                    Edit
                  </button>
                )
              )}
              <button style={styles.closeBtn} onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default InvoiceVerification;